import { useIntl } from 'locales/index'
import React from 'react'
import { useHistory } from 'react-router'
import { Button, Typography } from '@commutifi-fe/ui'
import ClosedIllustation from '@commutifi-fe/custom-icons/svgs/Closed'
import styles from './styles.module.scss'

export function ExpiredSurvey() {
  const intl = useIntl()
  const history = useHistory()

  return (
    <div className={styles['expired-survey-card-layout']}>
      <ClosedIllustation className="u-margin-bottom--large" height={96} />
      <Typography.Title className="u-margin-bottom--small-3">
        {intl.formatMessage({ id: 'expiredSurvey.title' })}
      </Typography.Title>
      <Typography.Paragraph style={{ textAlign: 'center' }} size="lead">
        {intl.formatMessage({ id: 'expiredSurvey.description' })}
      </Typography.Paragraph>
      <Button type="primary" style={{ maxWidth: '200px' }} onClick={() => history.push('')}>
        {intl.formatMessage({ id: 'expiredSurvey.backButton' })}
      </Button>
    </div>
  )
}
